module.exports = __webpack_public_path__ + "img/timecloud-logo.1c09112a.png";